<ng-container *ngIf="appInstall.state$ | async as state">
  <div *ngIf="state.shouldShowFallbackBanner" class="app-open-cta">
    <div class="app-open-cta__content">
      <div class="app-open-cta__copy">
        <strong>{{ 'shared.open_app.title' | translate }}</strong>
        <span>{{ 'shared.open_app.description' | translate }}</span>
      </div>

      <div class="app-open-cta__actions">
        <button
          pButton
          type="button"
          class="p-button-rounded p-button-text app-open-cta__dismiss"
          icon="pi pi-times"
          [ariaLabel]="'common.close' | translate"
          (click)="appInstall.dismissFallbackBanner()"
        ></button>

        <button
          pButton
          pRipple
          type="button"
          class="p-button-rounded"
          icon="pi pi-external-link"
          iconPos="left"
          [label]="'shared.open_app.button' | translate"
          (click)="appInstall.retryOpenNativeApp()"
        ></button>
      </div>
    </div>
  </div>

  <div
    *ngIf="state.isChoiceModalOpen"
    class="app-open-cta-overlay"
    (click)="appInstall.closeChoiceModal()"
  >
    <div class="app-open-cta-overlay__dialog" (click)="$event.stopPropagation()">
      <button
        pButton
        type="button"
        class="p-button-rounded p-button-text app-open-cta-overlay__close"
        icon="pi pi-times"
        [ariaLabel]="'common.close' | translate"
        (click)="appInstall.closeChoiceModal()"
      ></button>

      <div class="app-open-cta-overlay__copy">
        <strong>{{ 'shared.install.choice_title' | translate }}</strong>
        <span>{{ 'shared.install.choice_description' | translate }}</span>
      </div>

      <div class="app-open-cta-overlay__actions">
        <button
          *ngIf="state.platform === 'android' || state.platform === 'ios'"
          pButton
          pRipple
          type="button"
          class="p-button-rounded"
          icon="pi pi-external-link"
          iconPos="left"
          [label]="'shared.install.open_native' | translate"
          (click)="appInstall.retryOpenNativeApp()"
        ></button>

        <button
          *ngIf="state.platform === 'ios' || state.canInstall"
          pButton
          pRipple
          type="button"
          class="p-button-rounded p-button-outlined"
          icon="pi pi-download"
          iconPos="left"
          [label]="'shared.install.install_pwa' | translate"
          (click)="appInstall.choosePwaInstall()"
        ></button>

        <button
          pButton
          pRipple
          type="button"
          class="p-button-rounded p-button-secondary"
          icon="pi pi-mobile"
          iconPos="left"
          [label]="'shared.install.install_native' | translate"
          (click)="appInstall.openNativeStore()"
        ></button>
      </div>
    </div>
  </div>

  <div
    *ngIf="state.platform === 'ios' && state.isPwaInstructionsOpen"
    class="app-open-cta-overlay"
    (click)="appInstall.closePwaInstructions()"
  >
    <div class="app-open-cta-overlay__dialog" (click)="$event.stopPropagation()">
      <button
        pButton
        type="button"
        class="p-button-rounded p-button-text app-open-cta-overlay__close"
        icon="pi pi-times"
        [ariaLabel]="'common.close' | translate"
        (click)="appInstall.closePwaInstructions()"
      ></button>

      <div class="app-open-cta-overlay__copy">
        <strong>{{ 'shared.install.ios_title' | translate }}</strong>
        <span>{{ 'shared.install.description_ios' | translate }}</span>
      </div>

      <div class="app-open-cta-overlay__instructions">
        <span>{{ 'shared.install.ios_step_1' | translate }}</span>
        <span>{{ 'shared.install.ios_step_2' | translate }}</span>
        <span>{{ 'shared.install.ios_step_3' | translate }}</span>
      </div>

      <div class="app-open-cta-overlay__footer">
        <button
          pButton
          type="button"
          class="p-button-rounded"
          [label]="'common.close' | translate"
          (click)="appInstall.closePwaInstructions()"
        ></button>
      </div>
    </div>
  </div>
</ng-container>
